import { subDays } from "date-fns/esm/fp";

const initialState = {
  menu_type: "",
  data: {
    value: "",
    label: "",
    access: {
      can_full_access: false,
      can_read: false,
      can_write: false,
    },
  },
  loading: false,
  range: {
    startDate: subDays(30, new Date()).toISOString(),
    endDate: new Date().toISOString(),
    key: "selection",
  },
  campaign: {
    name: "",
    campaignId: "",
  },
  port_count: 0,
  portfolio: {
    value: "",
    label: "",
    access: {
      can_full_access: false,
      can_read: false,
      can_write: false,
    },
  },
  walmart_advertiser: null,
  walmart_portfolio: null,
  rec_count: 0,
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case "AMZ_PRODILE_ID":
      return {
        ...state,
        data: action.payload,
      };
    case "AMZ_DATE_RANGE":
      return {
        ...state,
        range: action.payload,
      };
    case "AMZ_CAMPAIGN":
      return {
        ...state,
        campaign: action.payload,
      };

    case "AMZ_PORTFOLIO":
      return {
        ...state,
        portfolio: action.payload,
      };

    case "AMZ_PORTFOLIO_COUNT":
      return {
        ...state,
        port_count: action.payload,
      };

    case "WALMART_ADVERTISER":
      return {
        ...state,
        walmart_advertiser: action.payload,
      };

    case "WALMART_PORTFOLIO":
      return {
        ...state,
        walmart_portfolio: action.payload,
      };

    case "SET_MENU_TYPE":
      return {
        ...state,
        menu_type: action.payload,
      };

    case "SET_REC_COUNT":
      return {
        ...state,
        rec_count: action.payload,
      };

    default:
      return state;
  }
};

export default commonReducer;
